module.exports = __webpack_public_path__ + "static/media/logo.c80ac6f8.png";